/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default [
	[ "چه", "چه" ], [ "خواه", "خواه" ], [ "نه", "نه" ], [ "هم", "هم" ], [ "یا", "یا" ],
];
